enum WorkspaceProjectFundingMilestoneBatchMilestoneStatus {
  'To do' = 'To do',
  'In progress' = 'In progress',
  'Waiting for payment' = 'Waiting for payment',
  'Released' = 'Released',
}

export default WorkspaceProjectFundingMilestoneBatchMilestoneStatus
